import * as services from '../../../services/graphql/widgets/newsletter';

import widget from './widget';

export default {
  ...widget,
  services,
};
